import apiClient from './client';

export interface ScrapApproval {
  id: string;
  device: any;
  serialNumber: string;
  reason?: string;
  notes?: string;
  photos?: string[];
  status: 'pending' | 'approved' | 'rejected';
  requestedBy: any;
  approvedBy?: any;
  approvedAt?: string;
  rejectionReason?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateScrapApprovalDto {
  device: string;
  serialNumber: string;
  reason?: string;
  notes?: string;
  photos?: string[];
}

export interface ApproveScrapDto {
  notes?: string;
}

export const scrapApprovalsApi = {
  uploadPhotos: async (files: File[]): Promise<string[]> => {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('photos', file);
    });
    
    const response = await apiClient.post('/scrap-approvals/upload-photos', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.urls;
  },

  getAll: async (status?: string): Promise<ScrapApproval[]> => {
    const params = status ? { status } : {};
    const response = await apiClient.get('/scrap-approvals', { params });
    // Transform _id to id
    return response.data.map((item: any) => ({
      ...item,
      id: item._id || item.id,
    }));
  },

  getOne: async (id: string): Promise<ScrapApproval> => {
    const response = await apiClient.get(`/scrap-approvals/${id}`);
    const item = response.data;
    return {
      ...item,
      id: item._id || item.id,
    };
  },

  create: async (data: CreateScrapApprovalDto): Promise<ScrapApproval> => {
    const response = await apiClient.post('/scrap-approvals', data);
    const item = response.data;
    return {
      ...item,
      id: item._id || item.id,
    };
  },

  approve: async (id: string, data: ApproveScrapDto): Promise<ScrapApproval> => {
    const response = await apiClient.patch(`/scrap-approvals/${id}/approve`, data);
    const item = response.data;
    return {
      ...item,
      id: item._id || item.id,
    };
  },

  reject: async (id: string, reason: string): Promise<ScrapApproval> => {
    const response = await apiClient.patch(`/scrap-approvals/${id}/reject`, { reason });
    const item = response.data;
    return {
      ...item,
      id: item._id || item.id,
    };
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/scrap-approvals/${id}`);
  },
};
